import axios from "axios";


export const getCreditCardDetails = async (functionParameters = {}) => {
    console.log("======= I got all these parameter ", functionParameters);

    // alert("Getting the details ");
    // return false;

    const { preloaderClass, smetioPresentationId, smartbox, textClass, model, uniqueValues, titleClass, subTitleClass, paragraphClass } = functionParameters;
    // const { smetioPresentationId } = uniqueValues;

    preloaderClass.show();

    const setupIntentUrl = `${window.apiEndPoint}/stripeRoute/setupIntent/${window.userLanguage}`;

    const vitalDetails = await axios.get(setupIntentUrl, {}).then((response) => {

        const result = response.data;

        if (result.error) return window.smetioVisitor.showNotification({
            type: "danger",
            body: [{ message: result.msg }]
        });

        return result;

    }).catch((error) => {

        console.log(error);

        return window.smetioVisitor.showNotification({
            type: "danger",
            body: [{ message: "txt423" }]
        });

    }).finally(()=>{
        // preloaderClass.hide();
    });

    // console.log("This is the vital details ", vitalDetails);

    if(!vitalDetails) return false;

    const { clientSecret, setupIntentId, publicProfileId, billingAddressDetails, stripePublishableKey } = vitalDetails.msg;

    // $(`.smetio-data-presentation-extra-content-${smetioPresentationId}`).html(content);
    const newContent = `
        <div>
            <h2>${window["smetioTexts"]["txt482"]}</h2>
        </div>
    `;

    $(`.smetio-data-presentation-extra-content-${smetioPresentationId}`).html(newContent);
    $(`.smetio-data-presentation-submit-btn-${smetioPresentationId}`).attr("data-smetio-is-visible", false);
    
    window.smetioVisitor.showNotification({
        type: "friendly",
        body: [{ message: "txt482" }]
    });

    // smartbox.updateContent(newContent);
    

    let getParameters = "";

    for (const key in billingAddressDetails) {

        getParameters += `&${key}=${billingAddressDetails[key]}`;

    };

    getParameters = `?stripePublishableKey=${stripePublishableKey}${getParameters}&themeName=${window.themeName}&smetioPresentationId=${smetioPresentationId}`;

    const title = window["smetioTexts"]["txt474"];
    const link = `${window.defaultPath}collectCreditCardDetails/${publicProfileId}/${clientSecret}/${setupIntentId}/${window.userLanguage}${getParameters}`;
    // const link = `${window.defaultPath}collectCreditCardDetails_iframe/${publicProfileId}/${clientSecret}/${setupIntentId}/${window.userLanguage}${getParameters}`;


    // console.log("This is the language ", window.userLanguage);
    // console.log("This is the link ", link);

    const screenHeight = $(document).height();
    const screenWidth = $(document).width();
    const width = 300;
    const left = screenWidth - width;
    const creditCardWindow = window.open(link, "_blank", `status=no, titlebar=no, toolbar=no, scrollbars=no, resizable=no, location=no, menubar=no, top=0, left=${left}, width=${width}, height=${screenHeight}`);

    try {
        creditCardWindow.focus();
    } catch (error) {
        console.log(error);
        window.smetioVisitor.showNotification({
            type: "friendly",
            body: [{ message: "txt483" }]
        });
        $(`.smetio-data-presentation-extra-content-${smetioPresentationId}`).append(`<h2>${window["smetioTexts"]["txt483"]}</h2>`);
    };


    preloaderClass.hide();
    // const content = `
    //     <iframe 
    //         src="${link}" 
    //         frameborder="0" 
    //         title="${title}" 
    //         style="min-height: 100vh; height: 100vh; min-width: 100%; width: 100%; border:0;"
    //         sandbox="allow-scripts allow-same-origin allow-top-navigation allow-forms"
    //     ></iframe>    
    // `;

    // $(`.smetio-data-presentation-extra-content-${smetioPresentationId}`).html(content);

    // window.addEventListener("beforeunload", (event) => {
    //     event.preventDefault();
    //     event.returnValue = "";
    //     // event.returnValue = true;

    //     const dest = document.activeElement.href ? document.activeElement.href : document.activeElement.parentElement.href;

    //     console.log("This is the destination ", dest);

    //     console.log("You are about to leave the page ", event);

    //     return false;
    //     // alert("You are about to leave the page");
    // });



};
